import {useContext} from 'react';
import { kml  } from 'togeojson';

import {FarmContext} from './FarmContext';
import {AppContext} from './AppContext';
// import D3Slider from './D3Slider';


export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    /* eslint-disable no-mixed-operators */
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


export default function ImportControl() {
    const {setBoundary} = useContext(FarmContext);
    const {drawRef} = useContext(AppContext);
    const onChange = e => {
        if (e.target.files && e.target.files[0]) {
            const f = e.target.files[0];
            const reader = new FileReader();
            // for geojson
            if (f.name.endsWith('.json') || f.name.endsWith('.geojson')) {
                reader.onload = revt => {
                    const geojson = JSON.parse(revt.target.result);
                    geojson.features.forEach(f => {
                        f.id = uuidv4();
                    })
                    console.log('adding', geojson.features);
                    // TODO shouldn't this be handled by useEffect in FarmContext
                    setBoundary(b => {
                        const newFC = {type: 'FeatureCollection', features: [...b.features, ...geojson.features]};
                        drawRef.current.set(newFC);
                        return newFC;
                    });
                }
              reader.readAsText(f);

              // for kml
            } else if (f.name.endsWith('.kml')) {
                
                reader.onload = revt => {
                    const text = revt.target.result;
                    const xml = new DOMParser().parseFromString(text, "application/xml");
                    const geojson = kml(xml);
                    geojson.features.forEach(f => {
                        f.id = uuidv4();
                    })
                    console.log('adding', geojson.features);
                    setBoundary(b => {
                        const newFC = {type: 'FeatureCollection', features: [...b.features, ...geojson.features]};
                        drawRef.current.set(newFC);
                        return newFC;
                    });
                }
                reader.readAsText(f);

            } 
        }
    }

    return <div>
        {/* <D3Slider /> */}
        {<label htmlFor="file">Add a .geojson or .kml file</label>}
        <input id="file" type="file" onChange={onChange}/>
    </div>
}